import { classed } from "@trydig/ui";
import styles from "./Container.module.css";

export const Container = classed("div", styles.root);
